import { Box, styled } from '@mui/material';
import { DropdownList as _DropdownList } from '~/components/commons/DropdownList_v1';

export const ModalContainer = styled(Box)`
  width: 344px;
  background: #ffffff;
  padding: 0 !important;
`;

export const ModalHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  box-sizing: border-box;
  padding: 16px 24px;
  border-bottom: 1px solid #dee2ec;
`;

export const ModalTitle = styled(Box)`
  font-size: 14px;
  font-weight: 700;
  color: #2d2d2d;
`;

export const CloseButton = styled('button')`
  font-size: 18px;
  color: #2d2d2d;
  cursor: pointer;
  border: none;
  background: none;
`;

export const ModalBody = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px 24px;
`;

export const WarningText = styled(Box)`
  position: relative;
  padding-left: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #eb5757;
  word-break: keep-all;

  &::before {
    content: '•';
    position: absolute;
    left: 10px;
    top: 0;
  }
`;

export const FormField = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const FormLabel = styled('label')`
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  color: #2d2d2d;
`;

export const DropdownList = styled(_DropdownList)`
  height: 40px;

  .MuiAutocomplete-inputRoot.MuiInputBase-root.MuiOutlinedInput-root {
    padding-left: 12px;
    height: 40px;
    border: 1px solid #dee2ec;
    border-radius: 2px;
  }
  .MuiAutocomplete-input {
    padding-left: 12px !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  .MuiInputBase-input {
    color: #2d2d2d;
  }

  .MuiInputBase-input::placeholder {
    color: #a1b1ca;
    opacity: 1;
  }
`;

export const AmountRow = styled(Box)`
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;
`;

export const AmountInput = styled('input')`
  width: 100%;
  box-sizing: border-box;
  height: 40px;
  padding: 0 8px;
  border: 1px solid #dee2ec;
  border-radius: 2px;
  font-size: 14px;
  color: #2d2d2d;
  outline: none;

  &:focus {
    border-color: #2c62f6;
  }

  &:disabled {
    background: #f5f5f5;
    color: #a1b1ca;
  }

  &.refund {
    width: auto;
    min-width: 0;
    flex: 1 1 0;
  }
`;

export const CheckboxLabel = styled('label')`
  display: flex;
  align-items: center;
  column-gap: 8px;
  flex: 0 0 auto;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  color: #2d2d2d;
  cursor: pointer;
`;

export const CheckboxInput = styled('input')`
  width: 16px;
  height: 16px;
  margin: 0;
  border: 1px solid #dee2ec;
  cursor: pointer;
`;

export const Textarea = styled('textarea')`
  width: 100%;
  height: 104px;
  padding: 10px 8px;
  border: 1px solid #dee2ec;
  border-radius: 2px;
  background: #f3f8ff;
  font-size: 12px;
  line-height: 22px;
  color: #2d2d2d;
  outline: none;
  resize: none;

  &::placeholder {
    color: #a1b1ca;
    opacity: 1;
  }

  &:focus {
    border-color: #2c62f6;
  }
`;

export const ModalFooter = styled(Box)`
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
  padding: 24px 32px;
`;

export const FooterButton = styled('button')`
  width: 58px;
  height: 28px;
  border: 1px solid #dee2ec;
  border-radius: 4px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 700;
  color: #2d2d2d;
  cursor: pointer;

  &.primary {
    border-color: #2c62f6;
    background: #2c62f6;
    color: #ffffff;
  }
`;
